import { NavLink } from "react-router-dom";
import { getMobileNav } from "./navItems";

const tabClass = ({ isActive }) =>
  `flex flex-1 flex-col items-center gap-1 py-2 text-xs ${
    isActive ? "text-primary" : "text-muted-foreground"
  }`;

export function BottomTabs() {
  const navItems = getMobileNav();

  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 flex border-t border-border bg-card md:hidden">
      {navItems.map((item) => (
        <NavLink key={item.to} to={item.to} end={item.end} className={tabClass}>
          <item.icon size={20} />
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

export default BottomTabs;
